import { DataTableProp, DataTableServerProp, DataTableSortBy } from "@plugins/common/types";
import DeviceUtils from "@utils/device.utils";

export const handleSelectAll = (selectAll, value) => {
  selectAll(!value);
};
export const checkSelected = (isSelected, item) => {
  return isSelected({ value: item });
};
export const handleSelect = (select, item) => {
  select({ value: item });
};

export const generateCustomSortObject = (headers) => {
  const customSort = {};
  headers.forEach((header) => {
    if (header.sort) {
      customSort[header.key] = header.sort;
    }
  });
  return customSort;
};

export const getStartCount = (page, dataPerPage) => {
  return (page - 1) * dataPerPage;
};
export const getSortColumn = (sortBy: DataTableSortBy[]) => {
  if (sortBy.length === 0) {
    return "";
  }
  return sortBy[0].key;
};
export const getSortDirection = (sortBy: DataTableSortBy[]) => {
  if (sortBy.length === 0) {
    return "";
  }
  return sortBy[0].order === "asc" ? "ascending" : "descending";
};

export const initDataTableServerProps = (): DataTableServerProp => {
  return {
    headers: [],
    itemsPerPage: DeviceUtils.isMobile() ? 10 : 20,
    items: [],
    page: 1,
    itemPageStart: 0,
    totalRecords: 0,
    sortBy: [],
    loading: true,
    selected: [],
  } as DataTableServerProp;
};

export const initDataTableProps = (): DataTableProp => {
  return {
    headers: [],
    itemsPerPage: DeviceUtils.isMobile() ? 10 : 20,
    items: [],
    page: 1,
    sortBy: [],
    loading: true,
    selected: [],
  } as DataTableProp;
};
